import { isSubmitting } from 'redux-form'
import { FIND_LOWER_PRICE_FORM } from './constants'

export const isFindLowerPriceSubmitting = isSubmitting(FIND_LOWER_PRICE_FORM)
